export const SyntechSymbols = {
    SyntechService: Symbol.for("SyntechService"),
    SyntechProvider: Symbol.for("SyntechProvider")
}